export default "__VITE_ASSET__BXiItCSU__"